import { Observable } from "rxjs";

import { FacturaEstadoModel } from "../factura-estado.model";
import { RolesModel } from "../roles.model";

export abstract class FacturaEstadoGateway {
    abstract findAll(): Observable<[FacturaEstadoModel]>;

    abstract getRoles(username: string): Observable<[RolesModel]>;
}